import { Link } from 'react-router-dom';

import { TomatoHuntIcon } from './TomatoHunt';

/**
 * 사이트 하단 공통 푸터. 모든 안내는 한 페이지(/about)에 모아두고,
 * 각 링크는 그 페이지의 해당 섹션(앵커)으로 이동한다.
 *
 * 모바일에선 최소화한다 — 어차피 한 페이지라 핵심 3개(소개·약관·개인정보)만 남기고,
 * 소개 문구는 상단 헤더로 옮겼다. 숨은 토마토(footer 슬롯)는 모바일에서도 찾을 수
 * 있어야 하므로 링크 줄 끝에 남긴다.
 */
const LINKS: { label: string; hash: string; mobile?: boolean }[] = [
  { label: '헥토마토 소개', hash: 'intro', mobile: true },
  { label: '업데이트 이력', hash: 'changelog' },
  { label: '처음 오셨나요', hash: 'guide' },
  { label: 'ABOUT', hash: 'about' },
  { label: '이용약관', hash: 'terms', mobile: true },
  { label: '개인정보 처리방침', hash: 'privacy', mobile: true },
];

export function SiteFooter() {
  return (
    <footer className="mt-8 hairline-t bg-ink-50/60">
      <div className="mx-auto max-w-2xl px-5 py-8 max-sm:py-5">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2.5">
          {LINKS.map((l) => (
            <Link
              key={l.hash}
              to={`/about#${l.hash}`}
              className={`text-[13px] text-ink-500 transition hover:text-tomato-600 ${
                l.mobile ? '' : 'max-sm:hidden'
              }`}
            >
              {l.label}
            </Link>
          ))}
          {/* 모바일에서 아래 문구가 접혀도 숨은 토마토는 여기서 찾을 수 있다. */}
          <TomatoHuntIcon elementId="footer" className="sm:hidden" />
        </div>
        <p className="mt-5 text-[12px] leading-relaxed text-ink-400 max-sm:hidden">
          🍅 토마토 마켓 · 헥토 사내 벼룩시장
          <TomatoHuntIcon elementId="footer" className="ml-1 align-middle" />
          <br />
          회사 공식 시스템이 아닌, 구성원이 만든 비공식 도구예요.
        </p>
      </div>
    </footer>
  );
}
